module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic17.bdd9423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic17.png
// module id = 584
// module chunks = 1